import { Route } from "react-router-dom";
import Navigate from "./navigate";
import React from "react";

const createRoute = ({ path = "", redirectFrom = "", ...props }) => (
  <React.Fragment>
    <Route path={path} {...props} />
    {!!redirectFrom && (
      <Route path={redirectFrom} element={<Navigate to={"/" + path} />} />
    )}
  </React.Fragment>
);

export { createRoute };
export default Route;
